export const iconCaretDown = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.4998 13.5005H10.5005V16.4998H13.4998V13.5005Z" />
    <path d="M10.4988 10.4993H7.49951V13.4986H10.4988V10.4993Z" />
    <path d="M13.4998 10.4993H10.5005V13.4986H13.4998V10.4993Z" />
    <path d="M16.4988 10.4993H13.4995V13.4986H16.4988V10.4993Z" />
    <path d="M10.4988 7.5H7.49951V10.4993H10.4988V7.5Z" />
    <path d="M7.49934 7.5H4.5V10.4993H7.49934V7.5Z" />
    <path d="M13.4998 7.5H10.5005V10.4993H13.4998V7.5Z" />
    <path d="M16.4988 7.5H13.4995V10.4993H16.4988V7.5Z" />
    <path d="M19.4998 7.5H16.5005V10.4993H19.4998V7.5Z" />
  </svg>
);

export const walletIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.7901 10.96H15.8401V12.91H17.7901V10.96Z" />
    <path d="M22.16 10.09V9.21H21.29V3.97H20.42V3H18.67H1.97H1.87V3.98H1V19.9H1.87V20.77H20.41V19.89H21.28V14.65H22.15V13.78H23.03V10.09H22.16ZM19.54 14.66H20.21V19.7H18.66H2.06V4.07H20.21V5.72V9.21H14.97V10.09H14.1V13.78H14.97V14.65H18.46M21.95 13.58H15.16V10.28H21.95V13.58Z" />
  </svg>
);

export const bybitIconRound = (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1829_313714)">
      <rect width="40" height="40" rx="20" fill="black" />
      <path
        d="M7.61117 12.5847C7.33852 11.6444 7.92184 10.6705 8.87949 10.467L24.8564 7.07345C25.6148 6.91236 26.3853 7.28956 26.7232 7.9874L33.8993 22.8075L13.678 33.5079L7.61117 12.5847Z"
        fill="url(#paint0_linear_1829_313714)"
      />
      <path
        d="M7.82047 13.7401C7.53372 12.7481 8.19853 11.7339 9.22257 11.6011L30.3984 8.85471C31.2782 8.7406 32.0958 9.32821 32.2682 10.1985L35.3321 25.6713L13.51 33.4229L7.82047 13.7401Z"
        fill="white"
      />
      <path
        d="M8.37021 11.9919H28.5914C32.1918 11.9919 35.1104 14.9106 35.1104 18.5109V33.9364C35.1104 37.5368 32.1918 40.4554 28.5914 40.4554H11.7404C8.14007 40.4554 5.22142 37.5368 5.22142 33.9364V15.1407C5.22142 13.4017 6.63118 11.9919 8.37021 11.9919Z"
        fill="url(#paint1_linear_1829_313714)"
        stroke="url(#paint2_linear_1829_313714)"
        strokeWidth="0.442849"
      />
      <path d="M25.0686 24.4367V18.1221H26.3004V24.4367H25.0686Z" fill="#F7A600" />
      <path
        d="M11.0116 26.3215H8.37082V20.0068H10.9054C12.1371 20.0068 12.8549 20.6986 12.8549 21.7805C12.8549 22.481 12.3941 22.9336 12.0754 23.0844C12.4565 23.2619 12.9439 23.6606 12.9439 24.5033C12.9439 25.6828 12.1371 26.3215 11.0116 26.3215ZM10.8078 21.1067H9.60257V22.5614H10.8078C11.3303 22.5614 11.6232 22.269 11.6232 21.8344C11.6232 21.3991 11.331 21.1067 10.8078 21.1067ZM10.8874 23.6699H9.60257V25.2216H10.8874C11.4459 25.2216 11.7115 24.8668 11.7115 24.4414C11.7121 24.0155 11.4459 23.6699 10.8874 23.6699Z"
        fill="white"
      />
      <path
        d="M16.3377 23.7317V26.3215H15.1146V23.7317L13.2181 20.0068H14.5561L15.7348 22.5521L16.8955 20.0068H18.2335L16.3377 23.7317Z"
        fill="white"
      />
      <path
        d="M21.7392 26.3215H19.0984V20.0068H21.633C22.8648 20.0068 23.5826 20.6986 23.5826 21.7805C23.5826 22.481 23.1217 22.9336 22.803 23.0844C23.1841 23.2619 23.6715 23.6606 23.6715 24.5033C23.6709 25.6828 22.8641 26.3215 21.7392 26.3215ZM21.5354 21.1067H20.3302V22.5614H21.5354C22.058 22.5614 22.3508 22.269 22.3508 21.8344C22.3501 21.3991 22.058 21.1067 21.5354 21.1067ZM21.6151 23.6699H20.3302V25.2216H21.6151C22.1735 25.2216 22.4391 24.8668 22.4391 24.4414C22.4391 24.0155 22.1728 23.6699 21.6151 23.6699Z"
        fill="white"
      />
      <path d="M30.3134 21.1067V26.3215H29.0816V21.1067H27.4335V20.0068H31.9621V21.1067H30.3134Z" fill="white" />
    </g>
    <defs>
      <linearGradient id="paint0_linear_1829_313714" x1="7.52738" y1="12.1667" x2="34.1729" y2="10.8319" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FFD748" />
        <stop offset="1" stopColor="#F7A600" />
      </linearGradient>
      <linearGradient id="paint1_linear_1829_313714" x1="20.1659" y1="11.7705" x2="20.1659" y2="39.6768" gradientUnits="userSpaceOnUse">
        <stop stopColor="#38393C" />
        <stop offset="1" />
      </linearGradient>
      <linearGradient id="paint2_linear_1829_313714" x1="20.1659" y1="11.7705" x2="20" y2="37" gradientUnits="userSpaceOnUse">
        <stop stopColor="#404347" />
        <stop offset="1" />
      </linearGradient>
      <clipPath id="clip0_1829_313714">
        <rect width="40" height="40" rx="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
